// guards/
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CognitoService } from '../services/cognito.service';

type RoleGuardWithMeta = CanActivateFn & { __allowedGroups?: string[] };

export const roleGuard = (allowedGroups: string[]): CanActivateFn => {
  const guard: RoleGuardWithMeta = () => {
    const cognitoService = inject(CognitoService);
    const router = inject(Router);
    const userGroups = cognitoService.getUserGroups();
    const hasAccess = allowedGroups.some(g => userGroups.includes(g));
    return hasAccess ? true : router.createUrlTree(['/intranet/acces-interdit']);
  };

  guard.__allowedGroups = allowedGroups;
  return guard;
};